// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3OeEm","label":"Completed_label__31MfZ"};